// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__7pQR5","footer":"ReportModalFilter_footer__2QnxS"};